import * as React from 'react'
import { LogLevel, LogPointsConnector } from '../model'
import LogPointsConnectorIcon from './LogPointsConnectorIcon/LogPointsConnectorIcon'
import './LogPointsConnectorsItem.css'
import Checkbox from '@mulesoft/anypoint-components/lib/Checkbox'
import LogPointsLogLevelSelector from '../LogPointsLogLevelSelector/LogPointsLogLevelSelector'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'
import Tooltip from '@mulesoft/anypoint-components/lib/Tooltip'

export type ValueProps = {
  itemKey: string
  logPointsConnector: LogPointsConnector
  logLevelOptions: LogLevel[]
}

export type EventProps = {
  onLogLevelChange: (connectorId: string, logLevel: LogLevel) => void
  onCheckboxChange: (connectorId: string, checked: boolean) => void
}

export type Props = ValueProps & EventProps

const onCheckboxChange = (props: Props) => (e: { value: boolean }) => {
  props.onCheckboxChange(props.logPointsConnector.connector.id, e.value)
}

const onLogLevelChange = (props: Props) => (logLevel: LogLevel) => {
  props.onLogLevelChange(props.logPointsConnector.connector.id, logLevel)
}

const getCheckboxProps = (props: Props) => {
  const {itemKey, logPointsConnector} = props

  return {
    className: 'log-points-connectors-checkbox-item',
    testId: `${itemKey}-checkbox`,
    checked: logPointsConnector.checked,
    onChange: onCheckboxChange(props)
  }
}

const getIconProps = (props: Props) => {
  const {logPointsConnector, itemKey} = props

  return {name: logPointsConnector.connector.name, src: logPointsConnector.connector.icon, testId: `${itemKey}-icon`}
}

const getLogLevelSelectorProps = (props: Props) => {
  const {itemKey, logPointsConnector, logLevelOptions} = props

  return {
    logLevelOptions: logLevelOptions,
    selected: logPointsConnector.logLevel,
    testId: `${itemKey}-log-level-selector`,
    className: 'log-points-connectors-log-level-selector',
    onLogLevelChange: onLogLevelChange(props)
  }
}

const showWarningIcon = (props: Props) => {
  const logLevel = props.logPointsConnector.logLevel
  return logLevel === LogLevel.DEBUG || logLevel === LogLevel.TRACE
}

const warningIconMsg = (props: Props) => {
  const logLevel = props.logPointsConnector.logLevel
  return (
    <div className="log-points-connectors-item-debug-tooltip-content">
      <span>Generating {logLevel} logs may affect the performance of your application</span>
    </div>
  )
}

const LogPointsConnectorsItem = (props: Props) => {
  const {logPointsConnector} = props
  const checkBoxProps = getCheckboxProps(props)
  const iconProps = getIconProps(props)
  const logLevelSelectorProps = getLogLevelSelectorProps(props)
  const warningIcon = showWarningIcon(props)
  const warningIconMessage = warningIconMsg(props)

  return (
    <div className="log-points-connectors-item">
      <div className="log-points-connectors-item-left">
        <Checkbox {...checkBoxProps}/>
        <LogPointsConnectorIcon  {...iconProps}/>
        <span className="log-points-connector-item-name">{logPointsConnector.connector.name}</span>
      </div>
      <div className="log-points-connectors-item-right">
        { logPointsConnector.checked &&
          <div className="log-points-connectors-item-selector-container">
            { warningIcon &&
              <Tooltip className="log-points-connectors-item-debug-tooltip" content={warningIconMessage} position="bottom">
                  <IconPanel
                      className="log-points-connectors-item-debug-icon"
                      data-test-id="log-points-connectors-item-debug-icon"
                      name="warning-small"
                      size={15}
                      fill="#F2BE24"
                  />
              </Tooltip>
            }
            <LogPointsLogLevelSelector  {...logLevelSelectorProps}/>
          </div>
        }
      </div>
    </div>
  )
}

export default LogPointsConnectorsItem
